Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _makeIconWithDirectionMirroring = require('../../private/makeIconWithDirectionMirroring');

var _makeIconWithDirectionMirroring2 = _interopRequireDefault(_makeIconWithDirectionMirroring);

var _iconCategories = require('../../utils/iconCategories');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ListUlSvg = function () {
  function ListUlSvg(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        fillRule: 'evenodd',
        d: 'M3.49 1H1.51C.67 1 0 1.673 0 2.51v1.98C0 5.33.673 6 1.51 6h1.98C4.33 6 5 5.327 5 4.49V2.51C5 1.67 4.327 1 3.49 1zM4 4.49c0 .286-.223.51-.51.51H1.51A.504.504 0 0 1 1 4.49V2.51c0-.286.223-.51.51-.51h1.98c.286 0 .51.223.51.51v1.98zm2-.99a.5.5 0 0 1 .5-.5h17a.5.5 0 1 1 0 1h-17a.5.5 0 0 1-.5-.5zM3.49 7H1.51C.67 7 0 7.673 0 8.51v1.98C0 11.33.673 12 1.51 12h1.98C4.33 12 5 11.327 5 10.49V8.51C5 7.67 4.327 7 3.49 7zM4 10.49c0 .286-.223.51-.51.51H1.51a.504.504 0 0 1-.51-.51V8.51c0-.286.223-.51.51-.51h1.98c.286 0 .51.223.51.51v1.98zm20-.99a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1 0-1h17a.5.5 0 0 1 .5.5zM3.49 13H1.51C.67 13 0 13.673 0 14.51v1.98C0 17.33.673 18 1.51 18h1.98C4.33 18 5 17.327 5 16.49v-1.98C5 13.67 4.327 13 3.49 13zM4 16.49c0 .286-.223.51-.51.51H1.51a.504.504 0 0 1-.51-.51v-1.98c0-.286.223-.51.51-.51h1.98c.286 0 .51.223.51.51v1.98zm20-.99a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1 0-1h17a.5.5 0 0 1 .5.5zM3.49 19H1.51C.67 19 0 19.673 0 20.51v1.98C0 23.33.673 24 1.51 24h1.98C4.33 24 5 23.327 5 22.49v-1.98C5 19.67 4.327 19 3.49 19zM4 22.49c0 .286-.223.51-.51.51H1.51a.504.504 0 0 1-.51-.51v-1.98c0-.286.223-.51.51-.51h1.98c.286 0 .51.223.51.51v1.98zm20-.99a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1 0-1h17a.5.5 0 0 1 .5.5z'
      })
    );
  }

  return ListUlSvg;
}();

ListUlSvg.componentCategory = 'Core';
ListUlSvg.displayName = 'ListUlSvg';
ListUlSvg.defaultProps = {
  viewBox: '0 0 24 24'
};


var IconListUl = (0, _makeIconWithDirectionMirroring2['default'])(ListUlSvg, 'IconListUl');
exports['default'] = IconListUl;


if (process.env.NODE_ENV !== 'production') {
  IconListUl.categories = [_iconCategories.MISCELLANEOUS];
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/icons/IconListUl.js
// module id = 425
// module chunks = 19843951674672